export default "__VITE_ASSET__TccUsOnE__"